/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { pathwayTemplatesControllerCreate } from '../fn/pathway-templates/pathway-templates-controller-create';
import { PathwayTemplatesControllerCreate$Params } from '../fn/pathway-templates/pathway-templates-controller-create';
import { pathwayTemplatesControllerFilter } from '../fn/pathway-templates/pathway-templates-controller-filter';
import { PathwayTemplatesControllerFilter$Params } from '../fn/pathway-templates/pathway-templates-controller-filter';
import { pathwayTemplatesControllerFindOne } from '../fn/pathway-templates/pathway-templates-controller-find-one';
import { PathwayTemplatesControllerFindOne$Params } from '../fn/pathway-templates/pathway-templates-controller-find-one';
import { pathwayTemplatesControllerRemove } from '../fn/pathway-templates/pathway-templates-controller-remove';
import { PathwayTemplatesControllerRemove$Params } from '../fn/pathway-templates/pathway-templates-controller-remove';
import { pathwayTemplatesControllerUpdate } from '../fn/pathway-templates/pathway-templates-controller-update';
import { PathwayTemplatesControllerUpdate$Params } from '../fn/pathway-templates/pathway-templates-controller-update';
import { ResponsePathwayTemplateDto } from '../models/response-pathway-template-dto';

@Injectable({ providedIn: 'root' })
export class PathwayTemplatesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `pathwayTemplatesControllerCreate()` */
  static readonly PathwayTemplatesControllerCreatePath = '/thalea-pathways/pathway-templates';

  /**
   * Create a new pathway template.
   *
   * Creates a new pathway template with phases, visits, and tests.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pathwayTemplatesControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  pathwayTemplatesControllerCreate$Response(params: PathwayTemplatesControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponsePathwayTemplateDto>> {
    return pathwayTemplatesControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a new pathway template.
   *
   * Creates a new pathway template with phases, visits, and tests.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `pathwayTemplatesControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  pathwayTemplatesControllerCreate(params: PathwayTemplatesControllerCreate$Params, context?: HttpContext): Observable<ResponsePathwayTemplateDto> {
    return this.pathwayTemplatesControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<ResponsePathwayTemplateDto>): ResponsePathwayTemplateDto => r.body)
    );
  }

  /** Path part for operation `pathwayTemplatesControllerFilter()` */
  static readonly PathwayTemplatesControllerFilterPath = '/thalea-pathways/pathway-templates/filter';

  /**
   * Filter pathway templates.
   *
   * Retrieves pathway templates based on filtering criteria.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pathwayTemplatesControllerFilter()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  pathwayTemplatesControllerFilter$Response(params: PathwayTemplatesControllerFilter$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ResponsePathwayTemplateDto>>> {
    return pathwayTemplatesControllerFilter(this.http, this.rootUrl, params, context);
  }

  /**
   * Filter pathway templates.
   *
   * Retrieves pathway templates based on filtering criteria.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `pathwayTemplatesControllerFilter$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  pathwayTemplatesControllerFilter(params: PathwayTemplatesControllerFilter$Params, context?: HttpContext): Observable<Array<ResponsePathwayTemplateDto>> {
    return this.pathwayTemplatesControllerFilter$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ResponsePathwayTemplateDto>>): Array<ResponsePathwayTemplateDto> => r.body)
    );
  }

  /** Path part for operation `pathwayTemplatesControllerFindOne()` */
  static readonly PathwayTemplatesControllerFindOnePath = '/thalea-pathways/pathway-templates/{tenant}/{type}';

  /**
   * Get a specific pathway template.
   *
   * Retrieves a pathway template by tenant and type.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pathwayTemplatesControllerFindOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  pathwayTemplatesControllerFindOne$Response(params: PathwayTemplatesControllerFindOne$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponsePathwayTemplateDto>> {
    return pathwayTemplatesControllerFindOne(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a specific pathway template.
   *
   * Retrieves a pathway template by tenant and type.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `pathwayTemplatesControllerFindOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  pathwayTemplatesControllerFindOne(params: PathwayTemplatesControllerFindOne$Params, context?: HttpContext): Observable<ResponsePathwayTemplateDto> {
    return this.pathwayTemplatesControllerFindOne$Response(params, context).pipe(
      map((r: StrictHttpResponse<ResponsePathwayTemplateDto>): ResponsePathwayTemplateDto => r.body)
    );
  }

  /** Path part for operation `pathwayTemplatesControllerRemove()` */
  static readonly PathwayTemplatesControllerRemovePath = '/thalea-pathways/pathway-templates/{tenant}/{type}';

  /**
   * Delete a pathway template.
   *
   * Permanently deletes a pathway template.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pathwayTemplatesControllerRemove()` instead.
   *
   * This method doesn't expect any request body.
   */
  pathwayTemplatesControllerRemove$Response(params: PathwayTemplatesControllerRemove$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return pathwayTemplatesControllerRemove(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete a pathway template.
   *
   * Permanently deletes a pathway template.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `pathwayTemplatesControllerRemove$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  pathwayTemplatesControllerRemove(params: PathwayTemplatesControllerRemove$Params, context?: HttpContext): Observable<void> {
    return this.pathwayTemplatesControllerRemove$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `pathwayTemplatesControllerUpdate()` */
  static readonly PathwayTemplatesControllerUpdatePath = '/thalea-pathways/pathway-templates/{tenant}/{type}';

  /**
   * Update a pathway template.
   *
   * Updates an existing pathway template.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pathwayTemplatesControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  pathwayTemplatesControllerUpdate$Response(params: PathwayTemplatesControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponsePathwayTemplateDto>> {
    return pathwayTemplatesControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Update a pathway template.
   *
   * Updates an existing pathway template.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `pathwayTemplatesControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  pathwayTemplatesControllerUpdate(params: PathwayTemplatesControllerUpdate$Params, context?: HttpContext): Observable<ResponsePathwayTemplateDto> {
    return this.pathwayTemplatesControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<ResponsePathwayTemplateDto>): ResponsePathwayTemplateDto => r.body)
    );
  }

}
